.dialog-footer{margin-top:20px}
/*# sourceMappingURL=/ba/public/confirm-dialog.component.css.map */
